import * as React from 'react';
import * as request from 'superagent';
import {withStyles,
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@mui/styles';
import {Theme} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {APIError} from '~common/lib/types';
import ActionForm from '~common/form/action-form';
import Renderers from '~common/lib/renderers';
import URLManager from '~common/lib/url-manager';

const styles = (theme: Theme): StyleRules => ({
  container: {
    flex: 1,
    margin: 0
  },
  taskCard: {
    width: '100%',
    background: theme.palette.background.paper,
    border: '1px solid #ccc',
    minHeight: 200
  },
  caption: {
    textAlign: 'center',
    borderBottom: '1px solid #ccc',
    padding: 10
  },
  cardContent: {
    margin: '10px 15px 10px 15px'
  },
  countContent: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    minHeight: 120,
    fontSize: '3.0rem',
    cursor: 'pointer'
  },
  templateContent: {
    minHeight: 120
  },
  cardContentEven: {
    margin: '10px 15px 10px 15px',
    display: 'flex',
    justifyContent: 'space-around'
  },
  cardActions: {
    padding: 5
  }
});

interface Props {
  id: number;
  caption: string;
  renderers: any;
  element: any;

  chromeless?: boolean;
}

type State = {
  status: 'loading' | 'ready';
  data: any;
  error?: any;
};

class FormRenderer extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      status: 'loading',
      data: null
    };
  }

  // UNSAFE_componentWillReceiveProps(
  //   newProps: Props & WithStyles<keyof typeof styles>
  // ) {}

 componentDidMount() {
    const self = this;
    if (!this.props.element || !this.props.element.id) {
      console.error("No ID found on Props")
    } else {
    // console.log("Requesting: ", this.props.element.id)
    request
      .get('/api/dashboards/' + this.props.element.id)
      .set('accept', 'application/json')
      .send()
      .then((response) => {
        self.setState({status: 'ready', data: response.body});
      })
      .catch((err) => {
        if (err.response && err.response.text) {
          const apiErr = new APIError();
          apiErr.type = 'http';
          apiErr.message = err.response.text;
          self.setState({status: 'ready', error: apiErr});
        }
      });
    }
  }

  static register = () => {
    // console.log("Registering FormElementRenderer")
    if(!Renderers.find("FormElementRenderer")){
      // console.log("Registering FormElementRenderer")
      Renderers.register("FormElementRenderer", withStyles(styles)(FormRenderer))
    }
  }



  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {chromeless, renderers, element} = this.props;
    const {status, data} = this.state;
        
    var cardClass:string = "";
      if(classes){
        cardClass = classes.cardContent;
      }

    var cardContent: any = null; 

    switch (status) {
      case 'loading':
        return (
          <div className={classes.container}>
            <LoadingView compact classes={{}} />
          </div>
        );

      default:
        if (data && data.content) {
            delete element.title;
            cardContent = (
                <ActionForm
                data={{}}
                gridSpacing={3}
                definition={data.content.criteriaForm}
                actions={[
                    {
                    label: 'Go',
                    submit: true,
                    onClick: (formData, evt) => {

                        var newURL = `${window.location.protocol}//${
                        window.location.host
                        }${
                        element.elementAttributes.targetURL
                        }`
                        
                        if (newURL.indexOf("?") > -1) {
                          newURL+=`&q=${URLManager.getQueryStringValue(formData)}`
                        } else {
                          newURL+=`?q=${URLManager.getQueryStringValue(formData)}`
                        }
                        window.location.href = newURL;
                    }
                    }
                ]}
                />
            );
        }
    }


    return <div className={classes.container}>{cardContent}</div>;
  }
}

export default withStyles(styles)(FormRenderer);

